// extracted by mini-css-extract-plugin
export default {"description":"zEdJk","label":"XEpnU","select":"XfUNG","input":"plETT","subtitle":"QVxK6","container":"gKv0m"};